var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["header/search-close.j2"] = require( "header/search-close.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/search-form.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<div class=\"c-site-search__custom-wrapper\">\n\n    <input data-qa-search data-search-source=\"header\" autocomplete=\"off\" ";
if(!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_large") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_large")) {
output += " spellcheck=\"false\" autocorrect=\"off\" ";
;
}
output += " autocapitalize=\"off\" type=\"search\" name=\"q\" class=\"c-site-search__input js-site-search__input js-site-search-header-input\" placeholder=\"";
output += runtime.suppressValue((lineno = 4, colno = 350, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["search_search"])), env.opts.autoescape);
output += "\" aria-label=\"";
output += runtime.suppressValue((lineno = 4, colno = 382, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["search_search"])), env.opts.autoescape);
output += "\" />\n\n    <a class=\"c-site-search__clear-input js-clear-search-input\" data-qa-search-cancel>\n        ";
env.getTemplate("header/search-close.j2", false, "core/templates/header/search-form.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n    </a>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/search-form.j2"] , dependencies)